import { WorkspaceAuditLogsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/audit-logs')({
  component: WorkspaceAuditLogsRoute,
});
